<template>
  <div v-if="$slots.actions" class="flex items-center justify-end gap-2 mb-6">
    <slot name="actions" />
  </div>
</template>

<script setup>
defineProps({
  title:       { type: String, required: true },
  description: { type: String, default: '' },
})
</script>
